<div class="row mt-4 g-0" *ngIf="data.style == 'right'">
  <div class="col-12 col-lg-6">
    <div class="row g-0">
      <div class="col-6">
        <img [src]="data.leftTop.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
      <div class="col-6">
        <img [src]="data.leftBottom.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
      <div class="col-6">
        <img [src]="data.rightTop.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
      <div class="col-6">
        <img [src]="data.rightBottom.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
    </div>
  </div>

  <div class="col-12 col-lg-6">
    <img src="{{data.hero.image}}" alt="SmartDukaan" class="img-fluid w-100 h-100 object-fit-cover">
  </div>
</div>

<div class="row mt-4 g-0" *ngIf="data.style == 'left'">
  <div class="col-12 col-lg-6">
    <img src="{{data.hero.image}}" alt="SmartDukaan" class="img-fluid w-100 h-100 object-fit-cover">
  </div>

  <div class="col-12 col-lg-6">
    <div class="row g-0">
      <div class="col-6">
        <img [src]="data.leftTop.image" alt="iPhones" class="img-fluid w-100">
      </div>
      <div class="col-6">
        <img [src]="data.leftBottom.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
      <div class="col-6">
        <img [src]="data.rightTop.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
      <div class="col-6">
        <img [src]="data.rightBottom.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
    </div>
  </div>
</div>

<div class="row mt-4 g-0" *ngIf="data.style == 'center'">
  <div class="col-12 col-lg-3">
    <div class="row g-0">
      <div class="col-12">
        <img [src]="data.leftTop.image" alt="SmartDukaan" class="img-fluid w-100">
        <img [src]="data.leftBottom.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
    </div>
  </div>

  <div class="col-12 col-lg-6">
    <img src="{{data.hero.image}}" alt="SmartDukaan" class="img-fluid w-100 h-100 object-fit-cover">
  </div>

  <div class="col-12 col-lg-3">
    <div class="row g-0">
      <div class="col-12">
        <img [src]="data.rightTop.image" alt="SmartDukaan" class="img-fluid w-100">
        <img [src]="data.rightBottom.image" alt="SmartDukaan" class="img-fluid w-100">
      </div>
    </div>
  </div>
</div>

<div class="row mt-4 g-0" *ngIf="data.style == 'double'">
  <div class="col-6">
    <img src="{{data.doubleLeft.image}}" alt="SmartDukaan" class="img-fluid w-100 h-100 object-fit-cover">
  </div>
  <div class="col-6">
    <img src="{{data.doubleRight.image}}" alt="SmartDukaan" class="img-fluid w-100 h-100 object-fit-cover">
  </div>
</div>

<div class="row mt-4 g-0" *ngIf="data.style == 'single'">
  <div class="col-12">
    <img src="{{data.single.image}}" alt="SmartDukaan" class="img-fluid w-100 h-100 object-fit-cover">
  </div>
</div>
